import { differenceInHours, differenceInMinutes } from "date-fns";
import pluralize from "pluralize";

export const getShortTime = (eventDate: Date, now: Date = new Date()) => {
  const minutesAgo = differenceInMinutes(now, eventDate);
  if (minutesAgo < 2) {
    return "Just now";
  } else if (minutesAgo < 60) {
    return `${minutesAgo} ${pluralize("minute", minutesAgo)} ago`;
  }

  const hoursAgo = differenceInHours(now, eventDate);
  if (hoursAgo < 24) {
    return `${hoursAgo} ${pluralize("hour", hoursAgo)} ago`;
  }
};